import React from 'react';
import Section from '../Section';
import { Container, Row, Column } from '../Grid';
import Image from '../Image';
import OutboundLink from '../OutboundLink';
import './styles.scss';

const AboutPartners = () => (
  <Section className="about-partners">
    <Container>
      <h3 className="about-partners__heading">About The Partners</h3>
      <Row className="about-partners__row">
        <Column size={3} className="about-partners__logo-col">
          <OutboundLink to="https://sfi.usc.edu" target="_blank" rel="noopener noreferrer">
            <Image filename="Shoah-White-2x.png" alt="USC Shoah Foundation" />
          </OutboundLink>
        </Column>
        <Column size={9}>
          <p className="about-partners__text">
            The USC Shoah Foundation records, preserves, and shares survivor and witness
            testimonies so that all can learn from the past, reflect on the present, and
            build a better future. The collections archive is home to more than 60,000
            testimonies of survivors and witnesses of the Holocaust, contemporary
            antisemitism, the Armenian Genocide, and other mass atrocities and genocidal
            crimes of the twentieth and twenty-first centuries. It is the largest such
            collection in the world. Established in 1994, the USC Shoah Foundation found
            a permanent home at the University of Southern California in 2006. With
            survivor testimony at the center, the USC Shoah Foundation's innovative
            programming, global-impact strategies, and forward-looking research and
            education initiatives help preserve Holocaust memory and history, confront
            antisemitism, and strengthen democratic values.
          </p>
        </Column>
      </Row>
      <Row className="about-partners__row about-partners__row--last">
        <Column size={3} className="about-partners__logo-col about-partners__logo-col--light">
          <OutboundLink to="https://www.discoveryeducation.com" target="_blank" rel="noopener noreferrer">
            <Image filename="de-logo-positive.png" alt="Discovery Education" />
          </OutboundLink>
        </Column>
        <Column size={9}>
          <p className="about-partners__text">
            Discovery Education is the worldwide edtech leader whose state-of-the-art
            digital platform supports learning wherever it takes place. Through its
            award-winning multimedia content, instructional supports, and innovative
            classroom tools, Discovery Education helps educators deliver equitable
            learning experiences engaging all students and supporting higher academic
            achievement on a global scale. Discovery Education serves approximately
            4.5 million educators and 45 million students worldwide, and its resources
            are accessed in nearly 100 countries and territories.
          </p>
        </Column>
      </Row>
    </Container>
  </Section>
);

export default AboutPartners;
